<script setup lang="ts">
    import { Head } from '@inertiajs/vue3';
    import AppLayout from '@/layouts/AppLayout.vue';
    import PageCard from '@/components/PageCard.vue';
    import type { BreadcrumbItem } from '@/types';
    import PowerBI from '@/components/PowerBI.vue';

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'menu.power_bi',
        },
        {
            title: 'menu.power_bi_dashboard',
            href: route('v2.powerbi.dashboard.index'),
        },
    ];
</script>

<template>
    <Head :title="$t('menu.power_bi')" />

    <AppLayout :breadcrumbs="breadcrumbs">
        <PageCard>
            <PowerBI />
        </PageCard>
    </AppLayout>
</template>
